import { Box } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { GeneralTasksComponent } from './components/generalTasksComponent';
import { useGeneralTasksStore } from './hooks/useGeneralTasksStore';
import { GeneralTasksFilters, GeneralTasksTab, TaskScope } from './types/generalTasksTypes';

export const MyGeneralTeamTasks = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();

  useEffect(() => {
    generalTasksStore.resetAndFetchOptions();
    generalTasksStore.setTab(GeneralTasksTab.MY_TEAM_TASKS);
    generalTasksStore.setTeamScope(true)
  }, []);

  return (
    <Box px={0.25} py={2} width="100%" bgcolor={'#fff'}>
      <GeneralTasksComponent teamScopeOnly />
    </Box>
  );
});
